import {DateTime} from "luxon";
import {TagInterface} from "./interfaces/TagInterface";
import {Element} from "./Element";

export class Tag extends Element implements TagInterface {
    id: string;
    createdAt: string;
    updatedAt?: DateTime;
    isDeleted: boolean;
    isPublished: boolean;
    updatedBy: number;
    ownerId: number;
    title?: string;
    orderIndex?: number | null;

    protected dates: string[] = ['updatedAt'];

    constructor(data: TagInterface, schema = '') {
        super(data, schema);
    }
}
